import { LayoutAdministrare } from "@/components/administrare/LayoutAdministrare";

export default function AdministrareTargetare() {
  return (
    <LayoutAdministrare
      titlu="Targetare NIS2"
      descriere={
        <>
          Universul firmelor din România cu activități în scopul OUG 155/2024,
          construit din exportul ONRC de pe data.gov.ro („Firme înregistrate la
          Registrul Comerțului până la data de 02.09.2026”) și situațiile
          financiare 2025. Estimările sunt orientative: încadrarea și nivelul de
          risc finale se calculează în aplicație, cu datele fiecărei entități.
        </>
      }
    />
  );
}
